module.exports = __webpack_public_path__ + "img/xmasParty16.7ed5cd27.jpg";